import {createSlice} from '@reduxjs/toolkit';

interface ITopupLoanData {
  selectedLoanAmount: number;
  loanType: string;
  loanApplicationId: number | string;
  parentLoanId?: number | string;
  mpId: number | string;
}

interface ITopupLoanApplicationInitial {
  topupData: ITopupLoanData | null;
  isTopup: boolean;
  currency: string;
}

const initialState: ITopupLoanApplicationInitial = {
  topupData: null,
  isTopup: false,
  currency: '',
};

const topup = createSlice({
  name: 'topupLoanApplication',
  initialState,
  reducers: {
    setTopupData(state, actions) {
      state.topupData = actions.payload;
    },
    setIsTopup(state, actions) {
      state.isTopup = actions.payload;
    },
    setCurrency(state, actions) {
      state.currency = actions.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

const topupLoanApplicationReducer = topup.reducer;

export const topupLoanApplicationActions = topup.actions;

export default topupLoanApplicationReducer;
